module.exports = __webpack_public_path__ + "img/download.466abf28.svg";